/**
 * @generated SignedSource<<f8db1bb7df1f2bb4203e0d9a8eb04616>>
 * @relayHash 667e7e15e3acf11af479f2fba1578a00
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7a6887b56c4d12dff6e6a08204c5f64db7766eb1b2fd089b7fb6fd57ca8f3304

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "7a6887b56c4d12dff6e6a08204c5f64db7766eb1b2fd089b7fb6fd57ca8f3304",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
